module.exports = __webpack_public_path__ + "media/assets/images/blog/clienti_scontenti-small-18365068d5b5d85c9069c7e87c5c1393.jpeg";